import { IContractSearchQuery } from '@dealpoint/types'

const defaultSearchQuery: IContractSearchQuery = {
  contractInformationFilters: [],
  keyTermFilters: [],
  query: '',
  sortBy: 'title',
  sortOrder: 'asc',
}

export default defaultSearchQuery
